import { DateGap } from '@fabric-ui/utils';

export const DATE_TRUNC_FUNCTION_NAME = 'DATE_TRUNC' as const;

export const DATE_BUCKET_OPTIONS = {
  none: { title: 'None', value: 'none' },
  day: { title: 'Day', value: 'day' },
  week: { title: 'Week', value: 'week' },
  month: { title: 'Month', value: 'month' },
  year: { title: 'Year', value: 'year' },
} as const;

export const DATE_BUCKET_OPTIONS_ARR = [
  DATE_BUCKET_OPTIONS.none,
  DATE_BUCKET_OPTIONS.day,
  DATE_BUCKET_OPTIONS.week,
  DATE_BUCKET_OPTIONS.month,
  DATE_BUCKET_OPTIONS.year,
];

export const DATE_BUCKET_TO_DATE_GAP = {
  [DATE_BUCKET_OPTIONS.day.value]: DateGap.Day,
  [DATE_BUCKET_OPTIONS.week.value]: DateGap.Week,
  [DATE_BUCKET_OPTIONS.month.value]: DateGap.Month,
  [DATE_BUCKET_OPTIONS.year.value]: DateGap.Year,
};
